import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MyuError } from 'app/shared-components/Types/MyUError';

interface AnchorOrigin {
  vertical: 'top';
  horizontal: 'left' | 'center' | 'right';
}

interface MessageOptions {
  anchorOrigin: AnchorOrigin;
  autoHideDuration: number;
  message: string;
  variant: 'success' | 'info' | 'warning' | 'error' | null;
}

interface MessageState {
  state: boolean | null;
  options: MessageOptions;
}

const initialState: MessageState = {
  state: null,
  options: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
    autoHideDuration: 2000,
    message: 'Hi',
    variant: null,
  },
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    showMessage: (state, action: PayloadAction<Partial<MessageOptions>>) => {
      state.state = true;
      state.options = {
        ...initialState.options,
        autoHideDuration: action.payload.variant === 'error' ? 5000 : 3000,
        ...action.payload,
      };
    },
    hideMessage: (state) => {
      state.state = null;
    },
    showError: (state, err: PayloadAction<unknown>) => {
      state.state = true;
      state.options = {
        ...initialState.options,
        autoHideDuration: 5000,
        variant: 'error',
        message: (err.payload as MyuError).data ?? 'Something went wrong',
      };
    },
  },
});

export const { hideMessage, showMessage, showError } = messageSlice.actions;

export const selectFuseMessageState = ({ fuse }: { fuse: { message: MessageState } }) =>
  fuse.message.state;

export const selectFuseMessageOptions = ({ fuse }: { fuse: { message: MessageState } }) =>
  fuse.message.options;

export default messageSlice.reducer;
